import type React from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import { configure } from 'mobx';
configure({ disableErrorBoundaries: true });

export const JSNotificationModal: React.FC = () => {
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleClose = (): void => {
    setErrorOpen(false);
  };

  useEffect(() => {
    window.onerror = (event: Event | string): boolean => {
      // eslint-disable-next-line @typescript-eslint/no-base-to-string
      setErrorMessage(event.toString());
      setErrorOpen(true);
      console.error(event);
      return false;
    };
  }, []);

  return (
    <div>
      <Dialog open={errorOpen}>
        <ModalContainer>
          <DialogTitle id="screen-notification-dialog-title" sx={{ m: 0, p: 2, fontWeight: '600' }}>
            Something went wrong
          </DialogTitle>
          <DialogContent dividers>
            <ModalContentBody>{errorMessage}</ModalContentBody>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'end', alignItems: 'center' }}>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </ModalContainer>
      </Dialog>
    </div>
  );
};

const ModalContainer = styled.div`
  width: 590px;
  padding-bottom: 10px;
`;

const ModalContentBody = styled.div`
  p.current-year {
    text-align: right;
    font-size: 0.8em;
  }
`;
